<template>
  <div class="jdPopModel1">
    <div class="wrapper1">
      <el-form ref="form" :model="form" label-width="170px">
        <el-row :gutter="22">
          <el-col :span="12">
            <el-form-item label="仪器名称：">
              <el-input  maxlength="100" v-model="form.instrumentName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产厂商：">
              <el-input  maxlength="100" v-model="form.factoryName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="12">
            <el-form-item label="仪器编号：">
              <el-input  maxlength="50" v-model="form.serialNumber" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备型号：">
              <el-input maxlength="100" v-model="form.pattern" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="12">
            <el-form-item label="上次检定准确度：">
              <el-input  maxlength="100" v-model="form.accuracy" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上次检定时间：">
              <el-input maxlength="100" v-model="form.lastCalibrationTime" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="12">
            <el-form-item label="检定/校准单位：">
              <el-input maxlength="100" v-model="form.calibrationMechanism"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="12">
            <el-form-item label="本次检定准确度：">
              <el-input maxlength="100" v-model="form.currentAccuracy"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="本次检定/校准日期：">
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="form.calibrationTime"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="12">
            <el-form-item label="证书编号：">
              <el-input maxlength="100" v-model="form.certificate"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="下次检定/校准有效期：">
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="form.nextCalibrationTime"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
              <!-- <el-input v-model="form.nextCalibrationTime"></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="12">
            <el-form-item label="测量范围：">
              <el-input maxlength="100" v-model="form.measuringRange"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态：">
              <el-select
                :poper-append-to-body="false"
                v-model="form.states"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col>
            <el-form-item label="检定要求：">
              <el-input  maxlength="300" type="textarea" v-model="form.requirements"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col>
            <el-form-item label="检定/校准结果上传：">
              <el-upload
                class="avatar-uploader"
                :action="uploadUrl"
                :http-request="fileUpload"
                :file-list="files"
              >
                <el-button>选取文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="22">
          <el-col>
            <el-form-item label="证书截图上传：">
              <el-upload
                class="avatar-uploader"
                :action="uploadUrl"
                :http-request="myupload"
                :show-file-list="false"
                :accept="'image/*'"
                :before-upload="handleBeforeUpload"
              >
                <img v-if="imgURL" :src="imgURL" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row :gutter="22">
          <el-col>
            <el-form-item label="检定校准结果确认：">
              <el-input  maxlength="300" type="textarea" v-model="form.resultStr"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="footer">
      <el-button type="primary" @click="dispose(true)">确认</el-button>
      <el-button @click="dispose(false)">取消</el-button>
    </div>
  </div>
</template>
<script>
import { FileUrl } from "@/api/depotApi";
import axios from '@/util/request';
export default {
  props: {
    message: Object,
  },
  computed: {
    particular() {
      return this.message.current;
    },
  },
  data() {
    return {
      uploadUrl: "/admin/sys-file/upload", //上传地址
      imgURL: "", //证书截图在线地址
      certFileURL: "", //证书文件在线地址
      imageUrl: "",
      form: {
        instrumentName: "", //仪器名称
        serialNumber: "", //仪器编号
        factoryName: "", //生产厂商
        pattern: "", //设备型号
        measuringRange: "", //测量范围
        accuracy: "", //上次检定准确度
        lastCalibrationTime:"",
        currentAccuracy: "", //本次检定准确度
        calibrationMechanism: "", //检定/校准单位
        calibrationTime: "", //检定校准日期
        certificate: "", //证书编号
        nextCalibrationTime: "", //下次检定/校准有效期
        requirements: "", //检定要求
        photo: "", //证书截图
        resultStr: "", //检定校准结果确认
        states: "", //状态
        id: "",
        certFile:''//证书文件
      },
      options: [
        {
          value: 0,
          label: "正常",
        },
        {
          value: 1,
          label: "降级",
        },
        {
          value: 2,
          label: "停用",
        },
        {
          value: 3,
          label: "需维修",
        },
        {
          value: 4,
          label: "需检定",
        },
        {
          value: 5,
          label: "需保养",
        },
        {
          value: 6,
          label: "报废",
        },
      ],
      files: [],
    };
  },
  mounted() {
    Object.keys(this.form).forEach((key) => {
      // if (
      //   key == "id" ||
      //   key == "states" ||
      //   key == "pattern" ||
      //   key == "instrumentName" ||
      //   key == "serialNumber" ||
      //   key == "requirements" ||
      //   key == "accuracy" ||
      //   key == "factoryName" ||
      //   key == "calibrationMechanism"||
      //   key=="lastCalibrationTime"
      // ) {
      //   this.form[key] = this.particular[key];
      // }
      this.form[key] = this.particular[key];
    });
    if (this.particular.photoLink&&this.message.type=="edit"){
      this.imgURL = this.particular.photoLink;
    }
  },
  methods: {
    dispose(item) {
      let bolVal = item;
      const pick = (obj, arr) =>
        arr.reduce(
          (iter, val) => (val in obj && (iter[val] = obj[val]), iter),
          {}
        );
      let data = pick(this.form, [
        "id",
        "requirements",
        "states",
        "resultStr",
        "photo",
        "nextCalibrationTime",
        "calibrationTime",
        "calibrationMechanism",
        "certificate",
        "currentAccuracy",
        "measuringRange",
        "certFile",
      ]);
      if (bolVal) {
        if (!data.currentAccuracy) {
          this.$message({
            message: "请输入本次检定准确度",
            type: "warning",
          });
          return false;
        }
        if (!data.calibrationMechanism) {
          this.$message({
            message: "单位不能为空",
            type: "warning",
          });
          return false;
        }
        if (!data.calibrationTime) {
          this.$message({
            message: "检定校准日期不能为空",
            type: "warning",
          });
          return false;
        }
        if (!data.certificate) {
          this.$message({
            message: "证书编号不为空",
            type: "warning",
          });
          return false;
        }
        if (!data.nextCalibrationTime) {
          this.$message({
            message: "下次检定/校准有效期不为空",
            type: "warning",
          });
          return false;
        }
        if (!data.measuringRange) {
          this.$message({
            message: "测量范围不为空",
            type: "warning",
          });
          return false;
        }
        if (!data.requirements) {
          this.$message({
            message: "请填写检定要求",
            type: "warning",
          });
          return false;
        }
        if (!data.certFile) {
          this.$message({
            message: "请上传检定/校准结果",
            type: "warning",
          });
          return false;
        }
        // if (!data.photo) {
        //   this.$message({
        //     message: "请上传证书截图",
        //     type: "warning",
        //   });
        //   return false;
        // }
        if (!data.resultStr) {
          this.$message({
            message: "请填写检定校准结果",
            type: "warning",
          });
          return false;
        }
        //用于解决后台日期格式问题
        if (data.calibrationTime.split(" ").length < 2){
          data.calibrationTime=data.calibrationTime;
        }
        if (data.nextCalibrationTime.split(" ").length < 2){
          data.nextCalibrationTime=data.nextCalibrationTime;
        }
      } else {

      }
      this.$emit("dispose", bolVal, data);
    },
    myupload(item) {
      let that = this;
      let fileObj = item.file;
      const form = new FormData();
      form.append("file", fileObj);
      axios({
        url: item.action,
        headers: { 'Content-Type': 'multipart/form-data' },
        method: 'post',
        data: form
      }).then(res => {
        if (res.succeed) {
          that.form.photo = res.data.fileName;
          FileUrl({ objectName: res.data.fileName }).then((res) => {
            that.imgURL = res.data;
          });
        }
        else {
          if (res.code === '401') {
            that.$message.error('登录过期，请重新登录！');
            setTimeout(()=>{
              window.sessionStorage.clear();
              window.localStorage.clear();
              window.location.href= "/login";
            },1000);
            that.$message.destroyed();
            return false;
          }
          else {
            that.$message.error(res.msg);
          }
        }
      }).catch((data) => {
        that.$message.error("上传失败,请重新上传图片!");
      });
    },
    handleBeforeUpload(file) {
      const isImage = file.type.includes("image");
      if (!isImage) {
        this.$message.error("上传文件类型必须是图片!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isImage && isLt2M;
    },
    fileUpload(item) {
      let that = this;
      let fileObj = item.file;
      this.files = [fileObj];
      const form = new FormData();
      form.append("file", fileObj);
      const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      axios({
        url: item.action,
        headers: { 'Content-Type': 'multipart/form-data' },
        method: 'post',
        data: form
      }).then(res => {
        if (res.succeed) {
          that.form.certFile = res.data.fileName;
          FileUrl({ objectName: res.data.fileName }).then((res) => {
            loading.close();
            that.certFileURL = res.data;
          });
        }

        else {
          loading.close();
          if (res.code === '401') {
            that.$message.error('登录过期，请重新登录！');
            setTimeout(()=>{
              window.sessionStorage.clear();
              window.localStorage.clear();
              window.location.href= "/login";
            },1000);
            that.$message.destroyed();
            return false;
          }
          else {
            that.$message.error(res.msg);
          }
        }
      }).catch((data) => {
        loading.close();
        that.$message.error("上传失败,请重新上传图片!");
      });
    },
  },
};
</script>

<style lang="less" scopde>
.jdPopModel1 {
  width: 100%;
  // height: 360px;
  color: black;
  .el-form-item{
  margin-bottom: 10px;
}
  .wrapper1 {
    .row-item {
      margin: 16px 0px;
      display: flex;
      .list-item-btn{
        display: inline-block;
        margin: auto;
        padding: 0 20px;
        height: 28px;
        line-height: 28px;
        text-align: center;
      }
    }
  }
  .footer {
    clear: both;
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .avatar-uploader .el-upload {
    border: 2px solid #0090f0;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #74c8fe;
    width: 108px;
    height: 108px;
    line-height: 108px;
    text-align: center;
  }
  .avatar {
    width: 108px;
    height: 108px;
    display: block;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Instrumentmanagemen/components/jdPopModel1.vue